import axios from 'axios';

export async function applyDiscount(couponCode, products) {
    try {
        const response = await axios.get('/api/get-coupon');
        const coupons = response.data.coupons;
        const coupon = coupons.find(coupon => coupon.code === couponCode);
        if (!coupon) {
            throw new Error('Cupón no existe');
        }

        let message = 'Cupón no válido';  // Default message
        let color = 'text-red-500';        // Default color
        let discountApplied = false;        // Flag to track if any discount was applied
        let totalDiscount = 0;             // Variable to accumulate total discount
        let session_id

        for (const item of products.products) {
            if (coupon.product_ids.includes(item.product_id)) {
                if (coupon.discount_type === 'percent') {
                    const discountAmount = ((Number(item.price) * Number(item.quantity)) * coupon.amount) / 100;
                    totalDiscount += discountAmount;  // Accumulate discount for this item
                    discountApplied = true;  // Set the flag to true
                    session_id = item.session_id
                } else {
                    message = 'Cupón no es tipo porcentaje';
                    color = 'text-red-500';
                }
            }
        }

        // After the loop, apply the total discount to the total amount
        // Call setDiscount with the accumulated discount value
        if (discountApplied) {
            // Send a request to the backend to update the discount values
            try {
                const response = await fetch('/api/add_discount_to_items', {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify({
                        code_discount: couponCode,  // assuming couponCode holds the discount code
                        discount_rate: coupon.amount,  // assuming coupon.amount is the discount rate
                        discount: totalDiscount,  // The total discount to apply
                        session_id: session_id,  // Replace with the actual session ID if needed
                    }),
                });
        
                if (!response.ok) {
                    throw new Error('Failed to update discount');
                }
        
                const result = await response.json();
                console.log(result);  // Optionally log the result of the backend response
        
                message = 'Cupón aplicado';
                color = 'text-[#22BB55]';  // Green color for success
            } catch (error) {
                console.error('Error updating discount:', error);
                message = 'Error al aplicar el cupón';
                color = 'text-red-500';  // Red color for failure
                throw new Error("Error updating discount:", error)
            }
        }
        

        return [totalDiscount, message, color];
    } catch (error) {
        const errorMessage = error.response ? error.response.data.error : error.message;
        throw new Error(errorMessage);
    }
}




export async function getDiscountRate(couponCode) {
    try {
        const response = await axios.get('/api/get-coupon');
        const coupons = response.data.coupons;
        const coupon = coupons.find(coupon => coupon.code === couponCode);
        return coupon.amount;
    }
    catch (error) {
        const errorMessage = error.response ? error.response.data.error : error.message;
        throw new Error(errorMessage);
    }
}

export async function checkDiscountValidation(session_id, setDiscount) {
    try {
      // Bring cart data
      const response = await fetch(`/api/get_products_for_cart?session_id=${session_id}`);
      if (!response.ok) throw new Error("Couldn't get data from server");
  
      const data = await response.json();
        const products = data.products;

        if (!products || products.length === 0) return;

        // Check if coupon is applied
        const appliedCode = products[0].code_discount;
        if (!appliedCode) return;

        // Get current coupons
        /* const couponResponse = await axios.get('/api/get-coupon');
        const coupons = couponResponse.data.coupons;
        const coupon = coupons.find(coupon => coupon.code === appliedCode); // Assuming `couponCode` should be `appliedCode`

        if (!coupon) return; */


        // Remove it from the cart
        await fetch(`/api/remove_discount?id=${session_id}`, {
            method: 'PATCH',
        });
        const newDiscount = await applyDiscount(appliedCode, data)
        setDiscount(newDiscount[0] > 0 ? newDiscount[0] : 0)
    } catch (err) {
      throw new Error(`Something went wrong in checkDiscountValidation: ${err}`);
    }
  }